var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "i") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Unroll-Marketing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "App-Password---4",
    transform: "translate(-820.000000, -444.000000)",
    fill: "#3E4852",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M827.000025,443.999951 C823.135428,443.999951 820,447.135378 820,450.999975 C820,454.864572 823.135428,458 827.000025,458 C830.864622,458 834.000049,454.864572 834.000049,450.999975 C834.000049,447.135378 830.864622,443.999951 827.000025,443.999951 Z M827.000025,448.331216 C826.431273,448.331216 825.935438,447.849964 825.935438,447.281212 C825.935438,446.727044 826.431273,446.202042 827.000025,446.202042 C827.568777,446.202042 828.064612,446.727044 828.064612,447.281212 C828.064612,447.849964 827.568777,448.331216 827.000025,448.331216 Z M825.979188,455.19999 C825.716687,455.19999 825.512519,454.995823 825.512519,454.733322 L825.512519,454.266654 C825.512519,454.004153 825.716687,453.799985 825.979188,453.799985 L825.979188,450.999975 C825.716687,450.999975 825.512519,450.795808 825.512519,450.533307 L825.512519,450.066639 C825.512519,449.804138 825.716687,449.59997 825.979188,449.59997 L827.568777,449.59997 C827.816694,449.59997 828.035445,449.804138 828.035445,450.066639 L828.020862,453.799985 C828.283362,453.799985 828.48753,454.004153 828.48753,454.266654 L828.48753,454.733322 C828.48753,454.995823 828.283362,455.19999 828.020862,455.19999 L825.979188,455.19999 Z",
    id: "i"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.ac42fb58fa3db75715b71ba940cb37ae.svg";
export { ForwardRef as ReactComponent };